import { Button } from '@mui/material';
import { makeStyles } from '@mui/styles';

type Props = {
  onClick: () => void;
};

const useStyles = makeStyles(() => ({
  container: {
    flex: 3,
  },
  button: {
    marginTop: '3px',
    padding: '2px 10px',
  },
}));

export default function AddResultItemButton({ onClick }: Props) {
  const classes = useStyles();

  return (
    <div className={classes.container}>
      <Button
        variant="contained"
        color="primary"
        size="small"
        className={classes.button}
        onClick={onClick}
      >
        + Add New Result Item
      </Button>
    </div>
  );
}
